import React, { useEffect, useMemo, useState, useContext } from 'react';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import MessagingContext from './Messaging.context';
import useMatchMedia from 'hooks/useMatchMedia';
import { SessionType } from 'models/Message';
import { useParams } from 'react-router-dom';
import api from 'api';
import { sentryError } from 'utils';
import { focusElement } from '../../pages/Chat/helpers';

type MessagingProviderType = {
  listingId?: string;
  dealRoomId?: string;
  listingEnquiryId?: string;
  sessionId?: string;
};

const Messaging: React.FC<MessagingProviderType> = (props) => {
  const {
    children,
    listingId,
    dealRoomId,
    listingEnquiryId,
    sessionId: propsSessionId,
  } = props;

  const { sessionId: paramsSessionId } = useParams<{ sessionId: string }>();

  const sessionId = useMemo(
    () => paramsSessionId || propsSessionId,
    [paramsSessionId, propsSessionId],
  );

  const { popServerError } = useContext(PopNotificationsContext);

  const isPhablet = useMatchMedia('isPhablet');

  const [loadingSession, setLoadingSession] = useState<boolean>(false);
  const [currentSession, setCurrentSession] = useState<SessionType>();

  const [contactOpen, setContactOpen] = useState<boolean>(false);
  const [contactsOpen, setContactsOpen] = useState<boolean>(false);

  const interlocutor = useMemo(() => {
    if (!currentSession) return null;
    return currentSession.interlocutor;
  }, [currentSession]);

  useEffect(() => {
    setContactOpen(!isPhablet);
    setContactsOpen(!isPhablet);
  }, [isPhablet]);

  useEffect(() => {
    if (!sessionId) return;

    (async () => {
      try {
        setCurrentSession(null);
        setLoadingSession(true);
        const { data } = await api.messages.getSessionById(sessionId);
        setCurrentSession(data);
        focusElement('#message-form-input');
      } catch (e) {
        sentryError(e);
        popServerError(e);
      } finally {
        setLoadingSession(false);
      }
    })();
  }, [popServerError, sessionId]);

  return (
    <MessagingContext.Provider
      value={{
        interlocutor,
        contactOpen,
        contactsOpen,
        loadingSession,
        currentSession,
        listingId,
        dealRoomId,
        listingEnquiryId,
        sessionId,
        setContactOpen,
        setContactsOpen,
        setCurrentSession,
      }}
    >
      {children}
    </MessagingContext.Provider>
  );
};

export default Messaging;
